module.exports = __webpack_public_path__ + "img/LATIN10_01.6c06a255.jpg";